import { useState, useCallback } from "react";

export const useEntityModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("create");
  const [data, setData] = useState(null);

  const openCreate = useCallback((initialData = null) => {
    setMode("create");
    setData(initialData); 
    setIsOpen(true);
  }, []);

  const openEdit = useCallback((entityData) => {
    setMode("edit");
    setData(entityData);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setData(null);
  }, []);

  return {
    isOpen,
    mode,
    data,
    openCreate,
    openEdit,
    close,
  };
};
